export const ROUTES = {
    HOME: 'home',
    LOGIN: 'login',
    FORGOT_PASSWORD: 'forgot-password',
    PROFILE: 'profile',
    COMPANY: {
        LIST: 'company-list',
        EDIT: 'company-edit',
        PRODUCTION: 'company-production',
        DASHBOARD: 'company-dashboard',
        ALL_UPLOADS: 'company-all-uploads',
    },
    HOLDING: {
        LIST: 'holding-list',
        EDIT: 'holding-edit',
        DASHBOARD: 'holding-dashboard',
    },
    METER: {
        LIST: 'meter-list',
        DETAIL: 'meter',
        ABSORBED_POWER: 'absorbed-power',
    },
    COLLABORATOR: {
        LIST: 'collaborator-list',
        EDIT: 'collaborator-edit',
    },
    CONTRACTS: {
        LIST: 'contracts-list',
    },
    REPORT: 'report',
    NOT_FOUND: 'not-found',
} as const

type FlattenRoutes<T> = T extends string ? T : T extends Record<string, infer V> ? FlattenRoutes<V> : never
export type RouteName = FlattenRoutes<(typeof ROUTES)[keyof typeof ROUTES]>
